import React from "react";
import "./NewCart.Module.css";
import { Typography, Box, Button, Dialog, DialogContent } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import toast from "react-hot-toast";

import ItemCart2 from "../../components/itemCart2/ItemCart2";
import beautiPerlas from "../../assets/beautiperlas.png";
import bolsaVacia from "../../assets/BOLSA_VACIA_OSCURA.png";
import CarouselOfertasCart from "../../components/carousel/CarouselOfertasCart";
import ModalConfirmation from "../../components/modals/modalConfirmation/ModalConfirmation";

import { borrarCarrito } from "../../features-slice/cart/carritoSlice";
import { obtenerCostoProductos, obtenerPuntosProductos } from "../../utils/products/products";
import { currencyDisplay } from "../../utils/cart/cart";
import { getSales, getDescuentos } from "../../utils/products/products";
import { isAuthenticated } from "../../utils/auth/auth";

export default function Pantalla1({
  close,
  setPantalla,
  costoConDescuento,
  descuentoAplicado,
  setDescuentoAplicado,
  metodoPago,
  costoConDescuentoPromo,
  totalDescontado
}) {
  const carrito = useSelector((state) => state.carrito);
  const cantidadPuntos = obtenerPuntosProductos(carrito);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const dispatch = useDispatch();

  const [codigoDescuento, setCodigoDescuento] = React.useState('');
  const [descuentos, setDescuentos] = React.useState([]);
  const [sales, setSales] = React.useState([]);
  const [showSales, setShowSales] = React.useState(true);
  const [showConfirmation, setShowConfirmation] = React.useState(false);
  const [showTerms, setShowTerms] = React.useState(false);

  const costoProductosPromo = React.useMemo(() => {
    return obtenerCostoProductos(carrito, "EFECTIVO");
  }, [carrito]);
// console.log("carrito", carrito)
  const handleShowTerms = () => setShowTerms(true);
  const handleShowTermsClose = () => setShowTerms(false);

  const handleShowConfirmation = () => setShowConfirmation(true);
  const handleConfirmClearCart = () => {
    localStorage.removeItem("cc");
    dispatch(borrarCarrito());
    toast.success("Bag vacía!");
    setShowConfirmation(false);
  };
  const handleCancelClearCart = () => setShowConfirmation(false);

  const aplicarDescuento = () => {
    const cupon = descuentos?.descuentos?.find((d) =>
      d.nombre.toLowerCase() === codigoDescuento.toLowerCase()
    );

    if (!cupon) return toast.error("Cupón no encontrado.");
    if (!cupon.estado) return toast.error("Cupón inactivo.");
    if (cupon.limiteUsos && cupon.usosRealizados >= cupon.limiteUsos) {
      return toast.error("Este cupón ya alcanzó su límite de usos.");
    }
if (cupon.tipoDescuento === '2x1') {
  const tag = cupon.tagAplicable?.toLowerCase();
// console.log("tag", tag)
  const cumple = carrito.some(item => {
    const cantidad = item.cantidad || 1;
    const tieneTag = item.tags?.some(t => t.toLowerCase() === tag) ||
                     item.tags2?.some(t => t.toLowerCase() === tag);

    // console.log('🧪 Revisando:', item.nombre, 'Cantidad:', cantidad, 'Tiene tag:', tieneTag);

    return cantidad >= 2 && tieneTag;
  });

  if (!cumple) {
    return toast.error("Para aplicar este cupón 2x1 necesitas 2 productos iguales en promo");
  }
}

    if (!['porcentaje', '2x1'].includes(cupon.tipoDescuento)) {
      return toast.error("Este tipo de cupón no está soportado.");
    }

    setDescuentoAplicado(cupon);
    toast.success("Cupón aplicado correctamente.");
  };

  React.useEffect(() => {
    const fetch = async () => setDescuentos(await getDescuentos());
    fetch();

    const listener = () => fetch();
    window.addEventListener('actualizar-descuentos', listener);
    return () => window.removeEventListener('actualizar-descuentos', listener);
  }, []);

  // arriba, dentro del componente
const totalItems = React.useMemo(
  () => carrito.reduce((acc, item) => acc + (item.cantidad ?? 1), 0),
  [carrito]
);

  React.useEffect(() => {
    async function getOfertas() {
      setSales(await getSales());
    }
    getOfertas();
  }, [carrito]);

  const politicas = [
    {
      pregunta: "CAMBIOS Y DEVOLUCIONES MARKET LA BEAUTIQUERIA",
      respuesta: "*Toda mercadería será chequeada antes de ser despachada.* \n Ante un cambio y/o devolución de producto, las alternativas son:  \n ♡  *Reemplazar el producto en día y horario a coordinar.*  \nEl cambio debe ser solicitado vía Whatsapp 341-5140700 indicando: nombre y apellido, dirección, horario de retiro (en caso de corresponder), número de pedido, código y descripción del producto, cantidad, motivo del cambio o devolución. \nEl cambio solo se realizará en sucursal previo control de esta información vía whatsapp y aprobación del mismo. \n *IMPORTANTE* \nPara cambiar o devolver un producto éste deberá conservar el envase original y  etiquetas originales y presentar la info anteriormente mencionada (nombre completo y número de pedido). \nEstos requisitos son INDISPENSABLES. \nAdemás se deberá considerar que, para los cambios, los productos  comprados en fechas especiales con ofertas se recibirán por el mismo valor del precio en promoción. \n *En ningún caso se devuelve el dinero.* \n *♡ NO TIENEN CAMBIO:* \nesmaltes, aceites, fragancias y relacionados. Aquellos productos donde no se puede verificar la modificación de su contenido. \n *♡Contemplamos los siguientes casos:* \n -El producto recibido no es el correspondiente al que Ud. seleccionó y el mismo no presentara anomalías (el empaque está cerrado) se procederá a realizar el cambio. \n -El producto solicitado no es del agrado de la persona que lo recibió y el mismo no fue abierto y no presenta anomalías (el empaque está cerrado) se podrá solicitar el cambio. \n -Si ha recibido un producto dañado deberá realizar el reclamo al instante al número de whatsapp  341-5140700 donde se le indicarán los pasos a seguir. \n Para todos los casos deberá comunicarse dentro de los 10 días desde  la recepción del pedido forma que se le indique como proceder. \n *♡El envío está a cargo del consumidor.*"
    },
    {
      pregunta: "POLÍTICA DE TURNOS BEAUTIQUEROS ",
      respuesta: "Cuando reservas un turno para utilizar un servicio beautiquero, estás generando un compromiso con *La Beautiqueria* de asistencia y nosotras de brindarte el servicio elegido. \nComo en nuestro salón no se pide seña, si no se cumple con la asistencia y no se realiza la cancelación con los tiempos correspondientes, el turno disponible no podrá ser utilizado por otra persona. \nPor eso establecemos estas políticas tanto para reservar como para cancelar, así todas podemos disfrutar de esta experiencia Beautiquera. \n♡Los turnos deben ser confirmados, respondiendo el mensaje que se envía desde la institución el día/ turno anterior. \n En caso de no haber recibido dicha respuesta  4 horas antes la cita quedará anulada y el turno liberado. \n La no confirmación de la reserva, implica una cancelación de la misma. ♡En caso de no asistir a tu cita, la misma debe ser cancelada con al menos 12 hs. *SOLAMENTE VIA WHATSAPP* \n ♡Todas tenemos imprevistos y emergencias, por lo cual, luego de no asistir a tu cita más de una vez, y de no haberla cancelado con la anticipación solicitada,*se cobrará una multa del 50%* del valor del servicio solicitado. \n En caso de que no desees abonarla, nuestro equipo podrá reservarse el derecho de brindarte una nueva cita.\n ♡Con el fin de respetar el tiempo de toda nuestra comunidad y de nuestro team , te pedimos que llegues puntual a su cita. \n *Contamos con 10 minutos de tolerancia.* \nLamentablemente no podremos atenderte en el caso de sobrepasar este tiempo.\n BRINDAR UNA EXPERIENCIA ÚNICA ES NUESTRA PRIORIDAD. \nEN EL CASO QUE NO ESTÉS SATISFECHA CON EL SERVICIO OFRECIDO, POR FAVOR SOLICITAMOS QUE NOS LO COMUNIQUES DENTRO DE LAS 24HS SIGUIENTES. \nNUESTRO TEAM SE COMPROMETE A RESOLVERLO Y MEJORAR EN EL CASO QUE SEA NECESARIO, Y SIEMPRE BRINDARTE LA MEJOR RESPUESTA. \nGRACIAS POR ELEGIRNOS♡ * # BEUTIQUEMOSELMUNDO *"
    }
  ];





  return (
    <div style={{ maxWidth: "100%" }}>
      <section className={showSales ? "sectionItemCart" : "sectionItemCartCerrado"}>
        {!carrito?.length ? (
          <div className="divBolsaVacia">
            <h3>La Beauti Bag está vacía!</h3>
            <img style={{ width: isMobile && "85px" }} src={bolsaVacia} alt="bolsaVacia" />
          </div>
        ) : (
          carrito.map((producto, index) => (
            <ItemCart2 producto={producto} index={index} key={index} />
          ))
        )}
        
      </section>
         <Typography sx={{
              display: "flex", 
              justifyContent: "space-between", 
              fontWeight: 400,
              fontFamily:"Poppins",
              fontSize:"14px", 
              textShadow:"none", 
              marginBottom:"2vh",
              marginTop:"10px"
   
              }}>
              Subtotal:
              <span style={{ fontWeight: 600,color: "#20563f",fontFamily:"Poppins", textShadow:"none" }}>
                {currencyDisplay(descuentoAplicado ? costoConDescuento : obtenerCostoProductos(carrito, metodoPago))}
              </span>
            </Typography>

      {carrito.length > 0 && (
        <section className="textoCart">
          <div className="divTransparencia pt-2 px-3">
            <div className="mb-3" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <Typography sx={{fontFamily:"Poppins", textShadow:"none", fontSize:"12px", fontWeight:600, color:"#000000"}}>
                  ¿Tenés un Cupón de descuento? Ingresalo acá:
              </Typography>
              <div style={{ display: "flex", width: "100%", justifyContent: "space-between", gap: "10px", marginTop: "5px" }}>
                <input
                  className="form-control"
                  style={{ maxWidth: "75%" }}
                  type="text"
                  value={codigoDescuento}
                  onChange={(e) => setCodigoDescuento(e.target.value)}
                  placeholder="Cupón"
                />
                <Button sx={{backgroundColor:"#20563f"}} variant="contained" size="small" onClick={aplicarDescuento}>
                  Aplicar
                </Button>
              </div>
              {descuentoAplicado && (
                <Typography style={{ marginTop: "8px", fontSize: "12px", color: "#20563f",fontFamily:"Poppins", textShadow:"none"}}>
                  Cupón <strong>{descuentoAplicado.nombre}</strong> aplicado: {descuentoAplicado.tipoDescuento !== "2x1" ? descuentoAplicado.porcentajeDescuento : "2x1"}
                </Typography>
              )}
                <Typography sx={{ fontSize: "12px", textAlign:"left", mt: 1 ,fontFamily:"Poppins", textShadow:"none"}}>
              *No acumulable con otos descuentos
            </Typography>
            </div>


            <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: 400,fontFamily:"Poppins", textShadow:"none", marginTop:"20px"}}>
              {totalItems} Articulo/s
              <span style={{ fontWeight: 600,color: "#20563f",fontFamily:"Poppins", textShadow:"none" }}>
                {currencyDisplay(descuentoAplicado ? costoConDescuento : obtenerCostoProductos(carrito, metodoPago))}
              </span>
            </Typography>
             <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: 400,fontFamily:"Poppins", textShadow:"none", marginTop:"20px" }}>
             Envío/Retiro:
              <span style={{ fontWeight: 600,color: "#20563f",fontFamily:"Poppins", textShadow:"none" }}>
                A CONVENIR
              </span>
            </Typography>
            <Typography sx={{
              display: "flex", 
              justifyContent: "space-between", 
              fontWeight: 400,
              fontFamily:"Poppins",
              fontSize:"22px", 
              textShadow:"none", 
              marginTop:"28px",
                borderTop: "1px solid #ccc", // 👈 línea arriba
    paddingTop: "10px" // para separar el texto de la línea
              }}>
              Total:
              <span style={{ fontWeight: 600,color: "#20563f",fontFamily:"Poppins", textShadow:"none" }}>
                {currencyDisplay(descuentoAplicado ? costoConDescuento : obtenerCostoProductos(carrito, metodoPago))}
              </span>
            </Typography>

            <Typography sx={{ fontSize: "12px", textAlign: "center", mt: 1 ,fontFamily:"Poppins", textShadow:"none"}}>
              ó {currencyDisplay(costoConDescuentoPromo)} abonando en efectivo en el local
            </Typography>

          

            <Box sx={{ paddingY: 3 }}>
              {/* <Typography sx={{ fontSize: "14px", color: "#bd969c" ,fontFamily:"Poppins", textShadow:"none"}}>
                ¡Estás sumando <strong>{cantidadPuntos}</strong> BeautiPerlas con esta compra!
              </Typography> */}

              <Box mt={2}>
                <Box onClick={() => setPantalla(3)} sx={{ backgroundColor: "#23563F", height: 48, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                  <Typography sx={{ color: "#fff", fontSize: "12px",fontFamily:"Poppins", textShadow:"none" }}>Iniciar Compra</Typography>
                </Box>
                <Box onClick={close} sx={{ height: 48, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                  <Typography sx={{ fontSize: "12px",fontFamily:"Poppins", textShadow:"none" }}>Seguir comprando</Typography>
                </Box>

                 <Box  sx={{ display:"flex", justifyContent:"center", alignItems:"center" ,width:"100%", flexDirection:"column", gap:"15px"}}>

                  {/* <Box onClick={handleShowTerms} sx={{ cursor: "pointer" }}>
                                <img style={{ width: "100%" }} src={beautiPerlas} alt="beautiperlas" />
                              </Box> */}
                                {/* {!isAuthenticated() && (
                      
                                      <Box  sx={{ backgroundColor: "#23563F", height: 48, display: "flex", alignItems: "center",width:"100%", justifyContent: "center", cursor: "pointer" }}>
                                  <Link to={"/iniciarSesion"}>
                  <Typography sx={{ color: "#fff", fontSize: "12px",fontFamily:"Poppins", textShadow:"none" }}>Estás registrada? Iniciá sesión</Typography>
                                  </Link>
                              
                </Box>
                              )} */}
                 </Box>
           

              
              </Box>
            </Box>
          </div>
        </section>
      )}
{/* 
      {showSales ? (
        <section className="sectionItemCartSale">
          <button className="buttonCerrarCartSale px-2" onClick={() => setShowSales(false)}>x</button>
          {sales?.productos && <CarouselOfertasCart sales={sales.productos} />}
        </section>
      ) : (
        <section className="sectionItemCartSale pt-2">
          <span className="vaciarCarrito px-4 py-2" onClick={() => setShowSales(true)}>Ver Ofertas</span>
        </section>
      )} */}

      {carrito.length > 0 && (
        <>
          <span className="vaciarCarrito px-4 py-2" onClick={handleShowConfirmation}>Vaciar Bag</span>
          <ModalConfirmation
            show={showConfirmation}
            title="Vaciar BeautiBag"
            message="¿Estás seguro de que deseas vaciar tu BeautiBag?"
            onConfirm={handleConfirmClearCart}
            onCancel={handleCancelClearCart}
          />
        </>
      )}

      <Typography sx={{ fontSize: "12px" }} className="terminos">Todos los derechos reservados © 2023 - 2024</Typography>

      <Dialog open={showTerms} onClose={handleShowTermsClose}>
        <DialogContent>
          {politicas.map((p, idx) => (
            <React.Fragment key={idx}>
              <Typography sx={{ fontWeight: "bold" }}>{p.pregunta}</Typography>
              {p.respuesta.split("\n").map((line, i) => (
                <Typography key={i} sx={{ fontSize: isMobile ? "12px" : "14px", textAlign: "left" }}>
                  {line.split(/(\*[^*]+\*)/).map((text, j) =>
                    text.startsWith("*") && text.endsWith("*") ? (
                      <strong key={j}>{text.slice(1, -1)}</strong>
                    ) : text
                  )}
                </Typography>
              ))}
            </React.Fragment>
          ))}
        </DialogContent>
      </Dialog>
    </div>
  );
}